import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, Mail, Phone, Globe, Camera } from 'lucide-react';
import Container from './Container';
import PoweredBy from '../common/PoweredBy';
import { useStoreContext } from '../../contexts/StoreContext';

// Footer enxuto pro storefront. Diferente do Footer institucional do Reviter
// (que ocupa esse arquivo: components/layout/Footer.js). Aqui o foco é
// suporte/atendimento da loja específica + powered-by no rodapé.
const StorefrontFooter = () => {
  const { store } = useStoreContext();
  const year = new Date().getFullYear();
  const whatsappLink = store?.contactPhone
    ? `https://wa.me/${String(store.contactPhone).replace(/\D/g, '')}`
    : null;

  return (
    <footer className="bg-app-surface border-t border-app-border mt-12">
      <Container>
        <div className="py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-bold text-app-text mb-2">{store?.name || 'Loja'}</h3>
            {store?.description && (
              <p className="text-sm text-app-text-secondary mb-4 max-w-sm leading-relaxed">
                {store.description}
              </p>
            )}
            <div className="flex items-center gap-3 text-app-text-secondary">
              {whatsappLink && (
                <a href={whatsappLink} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="hover:text-primary transition-colors">
                  <MessageCircle size={20} />
                </a>
              )}
              {store?.contactEmail && (
                <a href={`mailto:${store.contactEmail}`} aria-label="Email" className="hover:text-primary transition-colors">
                  <Mail size={20} />
                </a>
              )}
              {store?.contactWebsite && (
                <a href={store.contactWebsite} target="_blank" rel="noreferrer" aria-label="Site" className="hover:text-primary transition-colors">
                  <Globe size={20} />
                </a>
              )}
              <a href="#instagram" aria-label="Camera" className="hover:text-primary transition-colors">
                <Camera size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-app-text uppercase tracking-wider mb-3">
              Atendimento
            </h4>
            <ul className="space-y-2 text-sm text-app-text-secondary">
              {store?.contactEmail && (
                <li className="flex items-center gap-2">
                  <Mail size={14} />
                  <a href={`mailto:${store.contactEmail}`} className="hover:text-primary">{store.contactEmail}</a>
                </li>
              )}
              {store?.contactPhone && (
                <li className="flex items-center gap-2">
                  <Phone size={14} />
                  <span>{store.contactPhone}</span>
                </li>
              )}
              <li><Link to="/minha-conta/pedidos" className="hover:text-primary">Acompanhar pedido</Link></li>
              <li><a href="#trocas" className="hover:text-primary">Trocas e devoluções</a></li>
              <li><a href="#privacidade" className="hover:text-primary">Política de privacidade</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-app-text uppercase tracking-wider mb-3">
              Sua conta
            </h4>
            <ul className="space-y-2 text-sm text-app-text-secondary">
              <li><Link to="/entrar" className="hover:text-primary">Entrar</Link></li>
              <li><Link to="/cadastrar" className="hover:text-primary">Criar conta</Link></li>
              <li><Link to="/minha-conta" className="hover:text-primary">Minha conta</Link></li>
              <li><Link to="/carrinho" className="hover:text-primary">Sacola</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-app-border py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-app-text-secondary">
          <p>© {year} {store?.name || 'Loja'}. Todos os direitos reservados.</p>
          <PoweredBy />
        </div>
      </Container>
    </footer>
  );
};

export default StorefrontFooter;
